import { render, staticRenderFns } from "./goodAtPanel.vue?vue&type=template&id=abbc3d96&scoped=true&"
import script from "./goodAtPanel.vue?vue&type=script&lang=js&"
export * from "./goodAtPanel.vue?vue&type=script&lang=js&"
import style0 from "./goodAtPanel.vue?vue&type=style&index=0&id=abbc3d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbc3d96",
  null
  
)

export default component.exports